import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
// import localeData from 'dayjs/plugin/localeData'

dayjs.extend(duration);
// dayjs.extend(localeData)
